"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
function Discount(props) {
    var top = props.top, center = props.center, bottom = props.bottom;
    return (react_1.default.createElement("div", { className: "coupon-base-card" },
        react_1.default.createElement("div", { className: "card-title" }, top),
        react_1.default.createElement("div", { className: "card-save" }, center),
        react_1.default.createElement("span", { className: "card-num" }, bottom)));
}
exports.default = Discount;
//# sourceMappingURL=Discount.js.map